module.exports = __webpack_public_path__ + "static/media/logo_verme.1bf0ce6a.svg";